import React, {useState, useRef} from 'react'
import {Button, Modal} from "antd";
import {getDetailById} from "../../services/serviceProduction";
import ProductionDetailModal from "./ProductionDetailModal";
import {useReactToPrint} from "react-to-print";


const ProductionDetail = ({productionItem, updater}) => {

    const [detailModal, setDetailModal] = useState(false)
    const [production, setProduction] = useState([])

    const handleDetailClick = () => {
        getDetailById(productionItem.id)
            .then(({data}) => {
                setProduction(data)
                setDetailModal(!detailModal)
            })
    }
    const modalCloser = () => setDetailModal(!detailModal)
    const componentPrint = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentPrint.current,
    });

    return (
        <React.Fragment>
            <Button
                type={'link'}
                onClick={handleDetailClick}
            >
                Detay
            </Button>
            <Modal
                style={{
                    minWidth: '75%'
                }}
                open={detailModal}
                onCancel={() => modalCloser()}
                title={'Üretim Emri Detay'}
                footer={[
                    <Button
                        key={'CancelButton'}
                        type={'primary'}
                        onClick={() => modalCloser()}
                    >
                        Kapat
                    </Button>,
                    <Button
                        key={'Print'}
                        type={"primary"}
                        onClick={handlePrint}
                    >
                        Yazdır
                    </Button>
                ]}
            >
                <ProductionDetailModal ref={componentPrint} prodDetail={production}/>
            </Modal>
        </React.Fragment>
    )
}
export default ProductionDetail